import cookieUtil from "cookie";
import { i18n } from "app/i18n/i18n";
import preferencesConfig from "../data/preferences.json";

export const UI_LANG = "grp-ui-lang";
export const PUB_LANG = "grp-pub-lang";
export const TERMS_ACCEPTED = "grp-terms-accepted";
export const ASSET_CLASS = "grp-asset-class";
export const REGIONS = "grp-regions";
export const PAGE_SIZE = "grp-page-size";
export const PREFERENCES_PAGE = "grp-preferences-page";
export const VIEW = "grp-view";
export const DOMICILE = "grp-domicile";
export const MENU_SIDE = "grp-menu-side";
export const BULLETIN = "grp-bulletin";
export const REDESIGN = "grp-redesign";
export const JAPI = "grp-japi";
export const PAGINATION_POS = "grp-pagination-pos";
export const READERSHIP_LINK = "grp-readership-link";
export const REDESIGN_REMINDER = "grp-redesign-reminder";
export const REDESIGN_MODAL = "grp-redesign-modal";
export const REDESIGN_MODAL_REMIND_LATER = "grp-redesign-modal-remind-later";
export const FEEDBACK_MODAL = "grp-feedback-modal";

export const getPreferencesFromCookies = () => {
  const cookies = cookieUtil.parse(document.cookie);
  const initialPreferences = preferencesConfig.reduce((prefs, pref) => {
    const tempPrefs = prefs;
    tempPrefs[pref.id] = cookieOrDefaultValue(pref.id, pref.default, cookies);
    return tempPrefs;
  }, {});

  initialPreferences[UI_LANG] = getInitialLanguage();
  i18n.setLanguage(initialPreferences[UI_LANG][0]);
  return initialPreferences;
};

export const cookieOrDefaultValue = (cookieName, defaultValue, cookies) => {
  let tempCookies = cookies;
  if (!tempCookies) tempCookies = cookieUtil.parse(document.cookie);
  return tempCookies[cookieName] ? tempCookies[cookieName].split(",") : defaultValue;
};

const getInitialLanguage = () => cookieOrDefaultValue(UI_LANG, getDefaultLanguage());
const getDefaultLanguage = () => [getLangFromBrowserEnv() || "ja"];

const getLangFromBrowserEnv = () => {
  const lang = window.navigator.language.substr(0, 2);
  return ["en", "ja"].includes(lang) ? lang : null;
};
